import { Pages } from 'interfaces/main';
import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { prop_myPlans_openKeepPurchasePopupState } from '../store/plans/selectors';

const pagesNames = new Set<string>([
    `/${Pages.PROP}/${Pages.PROP__CHECKOUT}/`,
    `/${Pages.PROP}/${Pages.PROP__NEW_CHALLENGES}/${Pages.PROP__KEEPER__PURCHASE}/`,
]);

export const useDisableKeeperAlert = () => {
    const { pathname } = useLocation();
    const openKeepPurchasePopupState = useSelector(prop_myPlans_openKeepPurchasePopupState) as ReturnType<
        typeof prop_myPlans_openKeepPurchasePopupState
    >;

    return useMemo(() => {
        const fixedPathname = pathname.endsWith('/') ? pathname : `${pathname}/`;
        const matchPath = pathname ? pagesNames.has(fixedPathname) : false;
        return matchPath || openKeepPurchasePopupState?.isOpen;
    }, [pathname, openKeepPurchasePopupState?.isOpen]);
};
